import { Box, Tab, Tabs } from "@mui/material";
import { ComponentProps, useState } from "react";

import { CustomerProposalTab } from "./CustomerProposalTab";
import FinancialContent from "./FinancialContent";

type Props = ComponentProps<typeof FinancialContent>;

export function FinancialTabs({
    currentAccountId,
    currentCustomer,
    myParam,
    setCurrentCustomer,
}: Props) {
    const [tab, setTab] = useState<"billings" | "proposal">("billings");
    const customerId = currentCustomer?.id ?? Number(myParam);

    return (
        <>
            <Box sx={{ borderBottom: 1, borderColor: "divider", mb: 2 }}>
                <Tabs
                    value={tab}
                    onChange={(_, value) => setTab(value)}
                    variant="scrollable"
                    allowScrollButtonsMobile
                >
                    <Tab value="billings" label="Faturas" />
                    <Tab value="proposal" label="Proposta" />
                </Tabs>
            </Box>
            {tab === "billings" ? (
                <FinancialContent
                    currentAccountId={currentAccountId}
                    currentCustomer={currentCustomer}
                    myParam={myParam}
                    setCurrentCustomer={setCurrentCustomer}
                />
            ) : (
                <CustomerProposalTab customerId={customerId} />
            )}
        </>
    );
}
